import { currentAdapter } from './axiosClient'

export const getHoldings = async (accountId: string | undefined) => {
	return await currentAdapter.getHoldings(accountId)
}